<template>
  <b-card
    v-if="userData"
    class="card-congratulation-medal"
  >
    <h5>Bienvenido 👋 {{ userData.fullName }}!</h5>
  </b-card>
</template>

<script>
import { BCard, BLink } from "bootstrap-vue"

export default {
  components: {
    BCard,
    BLink,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("userData")),
    }
  },
}
</script>
